





















































import Vue from 'vue';
import CourseraService from '~/services/CourseraService';
import { CourseraCourse } from '~/models';
import { directive as clickaway } from 'vue-clickaway';

export default Vue.extend({
    name: 'CourseraSearch',
    directives: {
        onClickaway: clickaway,
    },
    data() {
        return {
            loading: false,
            query: '',
            prevQuery: '',
            results: [] as CourseraCourse[],
            noResults: false,

            hasFocus: false,
        };
    },
    computed: {
        showSearchButton(): boolean {
            return !this.loading && this.query !== '';
        },
    },
    methods: {
        async executeSearch() {
            if (!this.query || this.query === this.prevQuery) return;
            this.prevQuery = this.query;
            this.loading = true;

            const data = await CourseraService.searchCourses(this.query).finally(
                () => (this.loading = false)
            );

            this.results = data.result;
            this.noResults = !data.result.length;
        },
        away() {
            this.hasFocus = false;
            this.noResults = false;
        },
        handleKeyDown(event: KeyboardEvent) {
            this.hasFocus = true;
            if (event.key === 'Enter') this.executeSearch();
        },
    },
    watch: {
        query(value) {
            if (value === '') {
                this.prevQuery = '';
                this.results = [];
                this.noResults = false;
            }
        },
    },
});
